















import { Vue, Component, Watch } from 'vue-property-decorator'
import { sessionStore as store } from '@/store/session'
import { comfirmLogout } from '@/service/session/auth'

@Component
export default class TheHeader extends Vue {
  title = ''

  get avatar() {
    return store.user.avatar
  }

  @Watch('$route', { immediate: true })
  handleRouteChange() {
    const title = this.$route.meta!.title
    this.title = title || process.env.VUE_APP_TITLE
  }

  handldBack() {
    // TODO handle back logic
    this.$router.back()
  }

  handleCommand(command: string) {
    switch (command) {
      case 'logout':
        comfirmLogout()
        break
      default:
        break
    }
  }
}
